import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_breadcrumbs/_referenceBreadcrumb")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: "Reference",
      crumbPathname: "/reference",
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
